document.addEventListener('DOMContentLoaded', function () {
  var button = document.querySelector('[data-menu-button]');
  var nav = document.querySelector('[data-menu]');

  if (button && nav) {
    button.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImage = gallery.querySelector('.product-main-image img');
    var thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

    if (!mainImage || !thumbnails.length) return;

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        var imageUrl = thumbnail.getAttribute('data-image-url');
        var imageAlt = thumbnail.getAttribute('data-image-alt') || '';

        if (!imageUrl) return;

        mainImage.src = imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.alt = imageAlt;

        thumbnails.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-current', 'false');
        });

        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-current', 'true');
      });
    });
  });
});
